import { setDatadogRumContext, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import { initializeSharing } from "app/scripts/sharing"
import BuildAutomationDropdown from "app/scripts/build_automation_dropdown"
import UpdateParam from "app/scripts/update_param"
import SignedOutConnectButton from "app/scripts/signed_out_connect_button"
import TqaListTabs from "app/scripts/tqa_list_tabs"

import "stylesheets/unauthenticated_applet.scss"

sharedVanillaSetup()

document.addEventListener("DOMContentLoaded", function() {
  initializeSharing()
  SignedOutConnectButton()
  // remove access code from URL if it exists
  UpdateParam("code", null)

  window.addEventListener("appletEnabled", () => {
    document.querySelector(".connection-id.hide")?.classList.remove("hide")
    document.querySelector("div.delete.hide")?.classList.remove("hide")
    document.querySelector(".top_level_activity")?.classList.remove("hide")
  }, { once: true })

  window.addEventListener("appletEnabled", () => {
    document.querySelector(".connection-notifications-wrapper")?.classList.remove("hide")
  })

  window.addEventListener("appletDisabled", () => {
    document.querySelector(".connection-notifications-wrapper")?.classList.add("hide")
  })
}, { once: true })

Object.assign(window.App.Scripts, {
  BuildAutomationDropdown,
  UpdateParam,
  SetDatadogRumContext: setDatadogRumContext,
  TqaListTabs,
})
